import { render } from "./phoneComponentInline.vue?vue&type=template&id=6fd4044a&scoped=true"
import script from "./phoneComponentInline.vue?vue&type=script&lang=js"
export * from "./phoneComponentInline.vue?vue&type=script&lang=js"

import "./phoneComponentInline.vue?vue&type=style&index=0&id=6fd4044a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd4044a"]])

export default __exports__